import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

import { login as restLogin } from '../api/Rest/users';
import { LoginResult } from '../models/SessionStore';
import { UserListType } from '../models/UserStore/UserStore';
import { FirstParameter } from '../models/Utils';
import { useSessionStore } from '../stores/SessionStore';
import { useUserStore } from '../stores/UserStore';

// const { setKeyValue } = useKeyValueStore.getState();
const { login } = useSessionStore.getState();

const useSignIn = () => {
  // const signal = useAbortControllerSignal();
  // const { naviRef, useNavigation } = useNavigator();
  // const authNavigation = useNavigation<AuthScreen>();
  const navigate = useNavigate();

  const signIn = useCallback(
    async (
      body: FirstParameter<typeof restLogin>,
      setErrorMessage?: (text: string) => void,
      state?: Record<string, string>,
    ) => {
      const result = await login(body);
      if (
        result === LoginResult.Success ||
        result === LoginResult.SuccessReactivated
      ) {
        if (state) {
          const pageUrl = window.location.href;

          const updatedUrl = new URL(pageUrl);
          if (state.pathName) {
            updatedUrl.pathname = state.pathName;
          }

          const queryParams = new URLSearchParams();
          if (state.searchReferralCode) {
            queryParams.set('referralCode', state.searchReferralCode);
          }
          updatedUrl.search = queryParams.toString();

          const newUrl =
            updatedUrl.pathname +
            (updatedUrl.search ? `${updatedUrl.search}` : '');

          const finalUrl = decodeURIComponent(newUrl.toString());

          navigate(finalUrl, { replace: true });
        } else {
          navigate(-1);
        }
      } else if (result === LoginResult.InvalidCredentials) {
        setErrorMessage?.('You have entered an invalid username or password');
        // navigate(-1);
      } else if (result === LoginResult.InvalidPhoneNumber) {
        setErrorMessage?.(
          'You have entered an invalid phone number or password',
        );
        // navigate(-1);
      } else if (result === LoginResult.HaveSubAccounts) {
        const account = useUserStore
          .getState()
          .accounts.list(UserListType.Main)
          .get()[0];
        if (account) {
          await signIn({ ...body, loginAsUserId: account.userId });
        }
      } else {
        setErrorMessage?.('');
      }
    },
    [navigate],
  );
  return { signIn };
};

export default useSignIn;
